import { useAppSelector } from '@shared/store';

export const useModalStack = () => useAppSelector((state) => state.modalStack);
